import Global from "@/scripts/Global";
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'FolderCreate',
    data() {
        return {
            createNewFolder: false,
            new_folder_name: '',
        }
    },
    mounted() {
        document.getElementById("small_new_folder_name").focus()
    },
    methods: {
        createFolder() {
            Global.globalValue(VueSignals.CREATE_FOLDER, this.new_folder_name)
        }
    }
}
